import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'teal' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  isLoading = false,
  leftIcon,
  rightIcon,
  className = '',
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed rounded-md';
  const variants = {
    primary: 'bg-wh-pink text-white hover:bg-pink-600 focus:ring-wh-pink shadow-sm hover:shadow-md',
    secondary: 'bg-wh-yellow text-wh-black hover:bg-yellow-400 focus:ring-wh-yellow shadow-sm hover:shadow-md',
    teal: 'bg-wh-teal text-white hover:bg-teal-500 focus:ring-wh-teal shadow-sm hover:shadow-md',
    outline: 'border-2 border-wh-black text-wh-black hover:bg-gray-50 focus:ring-wh-black',
    ghost: 'text-gray-600 hover:text-wh-pink hover:bg-pink-50'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-271">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-272" />}
      {!isLoading && leftIcon && <span className="mr-2" data-id="element-273">{leftIcon}</span>}
      {children}
      {!isLoading && rightIcon && <span className="ml-2" data-id="element-274">{rightIcon}</span>}
    </button>;
}